module.exports = __webpack_public_path__ + "static/media/Facebook.117c3b3d.svg";